import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setItemId } from "../actions";
import {
  localStateSelector,
  makeLocalStateItemIdSelector,
  makeModuleReportSettingsSelector,
  makeReportIdSelector,
  makeReportOptionsSelector
} from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const itemIdSelector = makeLocalStateItemIdSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const reportIdSelector = makeReportIdSelector();
  const moduleReportSettingsSelector = makeModuleReportSettingsSelector();
  const reportOptionsSelector = makeReportOptionsSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    const itemId = itemIdSelector(state, props)!;
    const reportId = reportIdSelector(state, props)!;
    const reportOptions = reportOptionsSelector(state, props);
    return {
      ...props,
      alwaysShowRunButton: false,
      apiInfo: apiInfoSelector(state, props),
      fieldStyle: fieldStyleSelector(state, props),
      itemId,
      moduleReportSettings: moduleReportSettingsSelector(state, { id: itemId, source: props.source }),
      reportId,
      reportOptions,
      reloadTrigger: localState.reloadTrigger,
      useUrlState: false
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChangeItem: (itemId: string) => dispatch(setItemId({ id: props.id, source: props.source }, itemId))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
